import type { IStatusProps } from 'shared/ui/Status'

const statuses = ({
  failedReason,
  resultTitle,
}: {
  failedReason?: string | null
  resultTitle?: string | null
}): Record<string, IStatusProps> => {
  return {
    success: {
      title: resultTitle || 'Success',
      emphasis: 'high',
      intent: resultTitle ? 'deepPurple' : 'positive',
    },
    failed: {
      title: failedReason || '',
      emphasis: 'high',
      intent: 'neutral',
    },
  }
}

export default statuses
